import { render } from "./UpdateOrderStatus.vue?vue&type=template&id=a0299608"
import script from "./UpdateOrderStatus.vue?vue&type=script&lang=js"
export * from "./UpdateOrderStatus.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__